import type { Loadable } from "@/shared/lib/loadable";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { ValueWithLabel } from "@/widgets/value-with-label";
import { AccordionDetails } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";
import type { PreviewDeliveryProposalOfferCargo } from "../../../model";

export const CompanyForm = ({
  companies,
  previewValues,
}: {
  companies: Loadable<FreightMatching.schemas.Company[]>;
  previewValues: PreviewDeliveryProposalOfferCargo;
}) => {
  const selectedCompany =
    companies.status === "success"
      ? companies.data.find(
          (company) => company.id.toString() === previewValues.companyId,
        )
      : null;

  return (
    <BaseAccordion>
      <BaseAccordionSummary>運送会社</BaseAccordionSummary>
      <AccordionDetails>
        <ValueWithLabel
          label="運送会社"
          value={selectedCompany?.name || "未選択"}
        />
      </AccordionDetails>
    </BaseAccordion>
  );
};
